import { render, staticRenderFns } from "./PatientAddModal.vue?vue&type=template&id=c0771a80&scoped=true&"
import script from "./PatientAddModal.vue?vue&type=script&lang=js&"
export * from "./PatientAddModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0771a80",
  null
  
)

export default component.exports